// invoiceSlice.ts
import InvoiceBook from '../components/BookInvoiceForm';
import { BookData } from '../types/bookInvoice';
import createGenericSlice from './createGenericSlice';

// This will generate a slice specifically for boock nvoices
const bookInvoiceSlice = createGenericSlice<BookData>('book_invoices');

export const { addItem, editItem, deleteItem, copyItem, clearItems } = bookInvoiceSlice.actions;

export default bookInvoiceSlice.reducer;
